var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNoResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10647_78602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19464 75.8046C1.72679 73.3367 1.72679 69.3355 4.19464 66.8674L13.8462 57.216C16.3141 54.7481 20.3153 54.7481 22.7832 57.216C25.251 59.6839 25.251 63.6851 22.7832 66.153L13.1317 75.8046C10.6637 78.2724 6.6625 78.2724 4.19464 75.8046Z",
    stroke: "#D8D9FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5892 56.479C65.5382 56.479 77.6569 44.3604 77.6569 29.4113C77.6569 14.4622 65.5382 2.34363 50.5892 2.34363C35.6401 2.34363 23.5215 14.4622 23.5215 29.4113C23.5215 44.3604 35.6401 56.479 50.5892 56.479Z",
    stroke: "#D8D9FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0207 41.844C69.8867 34.978 69.8867 23.846 63.0207 16.98C56.1547 10.1139 45.0227 10.1139 38.1566 16.98C31.2906 23.846 31.2906 34.978 38.1566 41.844C45.0227 48.71 56.1547 48.71 63.0207 41.844Z",
    stroke: "#D8D9FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9341 34.7581L45.2422 24.0663",
    stroke: "#C0C0C0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9341 24.0663L45.2422 34.7581",
    stroke: "#C0C0C0",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7852 57.2172L31.4146 48.5878",
    stroke: "#D8D9FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10647_78602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResults);
export default __webpack_public_path__ + "static/media/icon-no-results.883aee39.svg";
export { ForwardRef as ReactComponent };